module.exports = __webpack_public_path__ + "img/bridge_logo.70d8ba31.png";